import React from 'react';
import { SlideTransition } from '../../../../components/Transition/Transition';
import { Dialog } from '@mui/material';
import WhatsappQRCode from '../WhatsappQRCode/WhatsappQRCode';

const WhatsappQRCodeDialog = props => {
  const { open, onClose, whatsapp, url, ...rest } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="whatsapp-qrcode-dialog"
      fullWidth={true}
      maxWidth="xs"
      {...rest}
      slots={{
        transition: SlideTransition
      }}>
      <WhatsappQRCode whatsapp={whatsapp} url={url} />
    </Dialog>
  );
};

export default WhatsappQRCodeDialog;
